import isNil from 'lodash/isNil';
import type { AnnotationLabelT, AnswerT, RangeSpanT } from '../../../../common/types/types';
import { type StoreTypeT, STORE_TYPE } from '../../../../common/types/types';
import { KEY_FRAME_TYPE } from '../../components/frames-control-panel/constants';
import { DYNAMIC_ATTRIBUTE_LS_TAG, DYNAMIC_ATTRIBUTE_TAG, EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants';
import type { AnnotationStoreT, AnnotationT } from '../../types';
import { type FrameStateT } from '../../types';
import { createKeyFrame } from '../../utils';
export const lockAnnotationLabelFromAnnotationStore = (annotationLabel: AnnotationLabelT, locked: boolean, annotationStore: AnnotationStoreT, selectedAnnotationIds: string[]): [AnnotationStoreT, string[]] => {
  Object.keys(annotationStore).forEach(annotationId => {
    const annotation = annotationStore[annotationId];
    // @ts-expect-error todo(ts-migration) TS2322 Type '{ locked: boolean | undefined; } | { locked: boolean | undefined; annotationType: "SEGMENTATION"; data: BrushDataT; metadata?: ({ answers?: AnswerT | undefined; mlData?: AnnotationMLDataT | unde...
    annotationStore[annotationId] = {
      ...annotationStore[annotationId],
      locked:
      // @ts-expect-error todo(ts-migration) TS18048 'annotation' is possibly 'undefined'.
      annotationLabel.title === annotation.annotationLabel.title ? locked : annotation.locked
    };
    if (locked) {
      selectedAnnotationIds = selectedAnnotationIds.filter(id => id !== annotationId);
    }
  });
  return [annotationStore, selectedAnnotationIds];
};
export const showHideAnnotationLabelFromAnnotationStore = (annotationLabel: string, hidden: boolean, annotationStore: AnnotationStoreT): AnnotationStoreT => {
  Object.keys(annotationStore).forEach(annotationId => {
    const annotation = annotationStore[annotationId];
    // @ts-expect-error todo(ts-migration) TS2322 Type '{ hidden: boolean | undefined; } | { hidden: boolean | undefined; annotationType: "SEGMENTATION"; data: BrushDataT; metadata?: ({ answers?: AnswerT | undefined; mlData?: AnnotationMLDataT | unde...
    annotationStore[annotationId] = {
      ...annotationStore[annotationId],
      // @ts-expect-error todo(ts-migration) TS18048 'annotation' is possibly 'undefined'.
      hidden: annotationLabel === annotation.annotationLabel.title ? hidden : annotation.hidden
    };
  });
  return annotationStore;
};
export const lockAnnotationFromAnnotationStore = (annotationId: string, locked: boolean, annotationStore: AnnotationStoreT): AnnotationStoreT => {
  // @ts-expect-error todo(ts-migration) TS2322 Type '{ [x: string]: AnnotationT | { locked: boolean; } | { locked: boolean; annotationType: "SEGMENTATION"; data: BrushDataT; metadata?: ({ answers?: AnswerT; mlData?: AnnotationMLDataT; originalId?:...
  return {
    ...annotationStore,
    [annotationId]: {
      ...annotationStore[annotationId],
      locked
    }
  };
};
export const showHideAnnotationFromAnnotationStore = (annotationId: string, hidden: boolean, annotationStore: AnnotationStoreT): AnnotationStoreT => {
  // @ts-expect-error todo(ts-migration) TS2322 Type '{ [x: string]: AnnotationT | { hidden: boolean; } | { hidden: boolean; annotationType: "SEGMENTATION"; data: BrushDataT; metadata?: ({ answers?: AnswerT; mlData?: AnnotationMLDataT; originalId?:...
  return {
    ...annotationStore,
    [annotationId]: {
      ...annotationStore[annotationId],
      hidden
    }
  };
};
export const showHideAllAnnotationsFromAnnotationStore = (hidden: boolean, annotationStore: AnnotationStoreT): AnnotationStoreT => {
  Object.keys(annotationStore).forEach(annotationId => {
    // @ts-expect-error todo(ts-migration) TS2322 Type '{ hidden: boolean; } | { hidden: boolean; annotationType: "SEGMENTATION"; data: BrushDataT; metadata?: ({ answers?: AnswerT | undefined; mlData?: AnnotationMLDataT | undefined; originalId?: stri...
    annotationStore[annotationId] = {
      ...annotationStore[annotationId],
      hidden
    };
  });
  return annotationStore;
};
export const handleLockAnnotationLabelFromAnnotationStore = (annotationLabel: AnnotationLabelT, locked: boolean, storeType: StoreTypeT | undefined | null, frames: FrameStateT[], selectedAnnotationIds: string[]): [FrameStateT[], string[]] => {
  frames.forEach(frame => {
    if (storeType === STORE_TYPE.ML_ANNOTATION_STORE) {
      [frame.annotationMLStore, selectedAnnotationIds] = lockAnnotationLabelFromAnnotationStore(annotationLabel, locked, {
        ...frame.annotationMLStore
      }, selectedAnnotationIds);
    } else {
      [frame.annotationStore, selectedAnnotationIds] = lockAnnotationLabelFromAnnotationStore(annotationLabel, locked, {
        ...frame.annotationStore
      }, selectedAnnotationIds);
    }
  });
  return [frames, selectedAnnotationIds];
};
export const handleShowHideAnnotationLabelFromAnnotationStore = (annotationLabel: string, hidden: boolean, storeType: StoreTypeT | undefined | null, frames: FrameStateT[]): FrameStateT[] => {
  frames.forEach(frame => {
    if (storeType === STORE_TYPE.ML_ANNOTATION_STORE) {
      frame.annotationMLStore = showHideAnnotationLabelFromAnnotationStore(annotationLabel, hidden, {
        ...frame.annotationMLStore
      });
    } else if (storeType === STORE_TYPE.CONSENSUS_ANNOTATION_STORE) {
      frame.annotationConsensusStore = showHideAnnotationLabelFromAnnotationStore(annotationLabel, hidden, {
        ...frame.annotationConsensusStore
      });
    } else {
      frame.annotationStore = showHideAnnotationLabelFromAnnotationStore(annotationLabel, hidden, {
        ...frame.annotationStore
      });
    }
  });
  return frames;
};
export const handleLockAnnotationFromAnnotationStore = (frameIndex: number | undefined, frameRange: [number, number][] | undefined, annotationId: string, locked: boolean, storeType: StoreTypeT | undefined | null, frames: FrameStateT[], selectedAnnotationIds: string[]): [FrameStateT[], string[]] => {
  if (storeType === STORE_TYPE.ML_ANNOTATION_STORE) {
    // @ts-expect-error missing null check
    frames[frameIndex].annotationMLStore = {
      ...lockAnnotationFromAnnotationStore(annotationId, locked, {
        // @ts-expect-error missing null check
        ...frames[frameIndex].annotationMLStore
      })
    };
    if (locked) {
      selectedAnnotationIds = selectedAnnotationIds.filter(id => id !== annotationId);
    }
  } else {
    if (!isNil(frameIndex)) {
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      frames[frameIndex].annotationStore = {
        ...lockAnnotationFromAnnotationStore(annotationId, locked, {
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          ...frames[frameIndex].annotationStore
        })
      };
      if (locked) {
        selectedAnnotationIds = selectedAnnotationIds.filter(id => id !== annotationId);
      }
    } else if (frameRange) {
      for (const [startFrameIndex, endFrameIndex] of frameRange) {
        for (let frameIndex = startFrameIndex; frameIndex <= endFrameIndex; frameIndex++) {
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          frames[frameIndex].annotationStore = {
            ...lockAnnotationFromAnnotationStore(annotationId, locked, {
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              ...frames[frameIndex].annotationStore
            })
          };
          if (locked) {
            selectedAnnotationIds = selectedAnnotationIds.filter(id => id !== annotationId);
          }
        }
      }
    }
  }
  return [frames, selectedAnnotationIds];
};
export const handleShowHideAnnotationFromAnnotationStore = (frameIndex: number | undefined, frameRange: [number, number][] | undefined, annotationId: string, hidden: boolean, storeType: StoreTypeT | undefined | null, frames: FrameStateT[]): FrameStateT[] => {
  if (storeType === STORE_TYPE.ML_ANNOTATION_STORE) {
    // @ts-expect-error missing null check
    frames[frameIndex].annotationMLStore = {
      ...showHideAnnotationFromAnnotationStore(annotationId, hidden, {
        // @ts-expect-error missing null check
        ...frames[frameIndex].annotationMLStore
      })
    };
  } else if (storeType === STORE_TYPE.CONSENSUS_ANNOTATION_STORE) {
    if (!isNil(frameIndex)) {
      // Handle specific frame
      if (frames[frameIndex]?.annotationConsensusStore?.[annotationId]) {
        frames[frameIndex].annotationConsensusStore = {
          ...showHideAnnotationFromAnnotationStore(annotationId, hidden, {
            ...frames[frameIndex].annotationConsensusStore
          })
        };
      }
    } else if (frameRange && frameRange.length > 0) {
      // Handle frame range
      for (const [startFrameIndex, endFrameIndex] of frameRange) {
        for (let frameIndex = startFrameIndex; frameIndex <= endFrameIndex; frameIndex++) {
          if (frames[frameIndex]?.annotationConsensusStore?.[annotationId]) {
            // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
            frames[frameIndex].annotationConsensusStore = {
              ...showHideAnnotationFromAnnotationStore(annotationId, hidden, {
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                ...frames[frameIndex].annotationConsensusStore
              })
            };
          }
        }
      }
    }
  } else {
    if (frameIndex !== undefined) {
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      frames[frameIndex].annotationStore = {
        ...showHideAnnotationFromAnnotationStore(annotationId, hidden, {
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          ...frames[frameIndex].annotationStore
        })
      };
    } else if (frameRange) {
      for (const [startFrameIndex, endFrameIndex] of frameRange) {
        for (let frameIndex = startFrameIndex; frameIndex <= endFrameIndex; frameIndex++) {
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          frames[frameIndex].annotationStore = {
            ...showHideAnnotationFromAnnotationStore(annotationId, hidden, {
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              ...frames[frameIndex].annotationStore
            })
          };
        }
      }
    }
  }
  return frames;
};
export const handleShowHideAllAnnotations = (hidden: boolean, storeType: StoreTypeT | undefined | null, frames: FrameStateT[]): FrameStateT[] => {
  frames.forEach(frame => {
    if (storeType === STORE_TYPE.ML_ANNOTATION_STORE) {
      if (frame.annotationMLStore) {
        frame.annotationMLStore = showHideAllAnnotationsFromAnnotationStore(hidden, {
          ...frame.annotationMLStore
        });
      }
    } else if (storeType === STORE_TYPE.CONSENSUS_ANNOTATION_STORE) {
      if (frame.annotationConsensusStore) {
        frame.annotationConsensusStore = showHideAllAnnotationsFromAnnotationStore(hidden, {
          ...frame.annotationConsensusStore
        });
      }
    } else {
      frame.annotationStore = showHideAllAnnotationsFromAnnotationStore(hidden, {
        ...frame.annotationStore
      });
    }
  });
  return frames;
};
export const findAnnotationData = (frames: FrameStateT[], annotationIdx: string, range: RangeSpanT): {
  startFrame: number;
  annotation: AnnotationT;
} | null => {
  for (let i = range.start; i <= range.end; i++) {
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    if (frames[i].annotationStore?.[annotationIdx]) {
      // @ts-expect-error todo(ts-migration) TS2322 Type 'AnnotationT | undefined' is not assignable to type 'AnnotationT'.
      return {
        startFrame: i,
        annotation: frames[i].annotationStore[annotationIdx]
      };
    }
  }
  return null;
};
export const getSortedAnnotationRanges = (annotationSequence: Map<string, RangeSpanT>): [number, number, string][] => {
  const annotationSequenceKeys = Array.from(annotationSequence.keys());
  const annotationSequenceRanges = annotationSequenceKeys.map((sequenceId: string) => ([annotationSequence.get(sequenceId)!.start, annotationSequence.get(sequenceId)!.end, sequenceId] as [number, number, string]));
  return annotationSequenceRanges.sort((a, b) => a[0] - b[0]);
};
export const removeAnnotationFrameSpans = (frames: FrameStateT[], annotationId: string, range: RangeSpanT, determineKeyFrameStatus: (isStartFrame: boolean) => boolean) => {
  const updatedFrames = [...frames];
  const {
    start: rangeStart,
    end: rangeEnd
  } = range;
  const effectiveStart = Math.max(0, rangeStart);
  const effectiveEnd = Math.min(rangeEnd, updatedFrames.length - 1);
  const effectiveRange = {
    start: effectiveStart,
    end: effectiveEnd
  };
  const {
    startFrame
  } = findAnnotationData(updatedFrames, annotationId, effectiveRange) ?? {};
  for (let frameIndex = effectiveStart; frameIndex <= effectiveEnd; frameIndex++) {
    const isStartFrame = frameIndex === startFrame;
    const keyFrame = determineKeyFrameStatus(isStartFrame);
    if (!keyFrame) {
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      const {
        [annotationId]: _,
        ...rest
      } = updatedFrames[frameIndex].annotationStore;
      // @ts-expect-error todo(ts-migration) TS2322 Type '{ annotationStore: { [key: string]: AnnotationT; }; imageUrl?: string | undefined; annotationMLStore?: AnnotationStoreT; annotationConsensusStore?: AnnotationStoreT; }' is not assignable to type...
      updatedFrames[frameIndex] = {
        ...updatedFrames[frameIndex],
        annotationStore: {
          ...rest
        }
      };
    }
  }
  return updatedFrames;
};
export const processAnnotationFrameSpans = (frames: FrameStateT[], annotationId: string, range: RangeSpanT, determineKeyFrameStatus: (isStartFrame: boolean) => boolean, frameAnnotations?: {
  [key: number]: AnnotationT;
}): FrameStateT[] => {
  const updatedFrames = [...frames];
  const {
    start: rangeStart,
    end: rangeEnd
  } = range;
  const effectiveStart = Math.max(0, rangeStart);
  const effectiveEnd = Math.min(rangeEnd, updatedFrames.length - 1);
  const effectiveRange = {
    start: effectiveStart,
    end: effectiveEnd
  };

  // Get the annotation data within the latest interpolation range
  const {
    startFrame,
    annotation
  } = findAnnotationData(updatedFrames, annotationId, effectiveRange) ?? {};
  const startFrameData = !frameAnnotations ? annotation : null;
  for (let frameIndex = effectiveStart; frameIndex <= effectiveEnd; frameIndex++) {
    const isStartFrame = frameIndex === startFrame;
    const keyFrame = determineKeyFrameStatus(isStartFrame);
    const frameSpecificData = frameAnnotations?.[frameIndex];
    const annotationToInsert = frameSpecificData ? {
      ...frameSpecificData,
      keyFrame: createKeyFrame(keyFrame, KEY_FRAME_TYPE.AUTOMATED)
    } : startFrameData ? {
      ...startFrameData,
      keyFrame: createKeyFrame(keyFrame, KEY_FRAME_TYPE.MANUAL)
    } : null;
    if (annotationToInsert) {
      // @ts-expect-error todo(ts-migration) TS2322 Type '{ annotationStore: { [x: string]: AnnotationT | { keyFrame: KeyFrameT; annotationType: "SEGMENTATION"; data: BrushDataT; metadata?: ({ answers?: AnswerT; mlData?: AnnotationMLDataT; originalId?:...
      updatedFrames[frameIndex] = {
        ...updatedFrames[frameIndex],
        annotationStore: {
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          ...updatedFrames[frameIndex].annotationStore,
          [annotationId]: annotationToInsert
        }
      };
    }
  }
  return updatedFrames;
};
export const filterDynamicAnswers = (answers?: AnswerT): AnswerT => {
  if (!answers) return EMPTY_OBJECT;
  const questionIds = Object.keys(answers);
  return questionIds.reduce((acc, questionId) => {
    const questionResponse = answers[questionId];
    const questionTags = questionResponse?.tags || EMPTY_ARRAY;
    if (questionTags.includes(DYNAMIC_ATTRIBUTE_TAG) || questionTags.includes(DYNAMIC_ATTRIBUTE_LS_TAG)) return acc;
    return {
      ...acc,
      [questionId]: answers[questionId]
    };
  }, EMPTY_OBJECT);
};
export const filterStaticAnswers = (answers?: AnswerT): AnswerT => {
  if (!answers) return EMPTY_OBJECT;
  const questionIds = Object.keys(answers);
  return questionIds.reduce((acc, questionId) => {
    const questionResponse = answers[questionId];
    const questionTags = questionResponse?.tags || EMPTY_ARRAY;
    if (!(questionTags.includes(DYNAMIC_ATTRIBUTE_TAG) || questionTags.includes(DYNAMIC_ATTRIBUTE_LS_TAG))) return acc;
    return {
      ...acc,
      [questionId]: answers[questionId]
    };
  }, EMPTY_OBJECT);
};